(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('ApplicationsFranchiserFormController', ApplicationsFranchiserFormController)

    /** @ngInject */
    function ApplicationsFranchiserFormController($state, $q, $stateParams, HttpService, HelperService, ApplicationService, ApplicationTypeService, AccessLevelService, sweetAlert) {
        const vm = this;
        let applicationOriginalData = {};

        // SYSTEM DEFAULT METHODS
        // vm.uiCanExit = () => {
        //     return HelperService.uiCanExit(applicationOriginalData, vm.applicationData);
        // }

        // vm.isDataModified = () => {
        //     return !angular.equals(vm.applicationData, applicationOriginalData);
        // }

        // vm.resetForm = () => {
        //     angular.copy(applicationOriginalData, vm.applicationData);
        // }

        // ÁREA CUSTOM METHODS
        // Main image
        vm.flowFileFinishedMain = ($file, $message) => {
            var message = angular.fromJson($message);

            vm.applicationData.Image = message.FileSaveName;
            vm.imageMain.display = HelperService.imageHandlerPath('application', vm.applicationData.Id, message.FileSaveName);

            vm.saveApplication();
        }

        vm.flowFilesAddedMain = () => {
            vm.oldFormImageMain = vm.applicationData.Image;
        }

        vm.deleteImageMain = () => {
            HttpService
                .delete('/files/delete/application/' + vm.applicationData.Id + '/' + vm.applicationData.Image)
                .then(
                    () => {
                        vm.applicationData.Image = '';
                        vm.imageMain.display = '';

                        if (vm.flowScopeMain.flow.files.length)
                            vm.flowScopeMain.flow.files[0].cancel();

                        vm.saveApplication();
                    },
                    error => errorCallback(error)
                );
        }

        vm.generateRandomHash = fromId => {
            HelperService.startLoading('.page-content');

            ApplicationService
                .generateRandomHash()
                .then(success => {
                    if (fromId == 1)
                        vm.applicationData.ClientId = success;
                    else
                        vm.applicationData.ClientSecret = success;

                    vm.saveApplication(false);
                })
        }

        vm.changeTab = tabId => {
            vm.selectedTab = tabId;
        }

        vm.changeApplicationStatus = status => {
            vm.applicationData.Active = status;
        }

        vm.onChangeAccessLevels = (isSelectAll = false) => {
            if (isSelectAll) {
                if (vm.selectAllAccessLevels)
                    vm.selectedAccessLevels = vm.accessLevels.map(accessLevel => accessLevel);
                else
                    vm.selectedAccessLevels = [];
            }

            if (vm.selectedAccessLevels.length == vm.accessLevels.length)
                vm.selectAllAccessLevels = true;
            else
                vm.selectAllAccessLevels = false;
        }

        vm.onAddEndPoint = (controller, isSelectAll = false) => {
            const originalEndPoints = angular.copy(vm.permissionEndPoints.filter(endPoint => endPoint.ApiControllerId == controller.Id));

            if (isSelectAll) {
                // Is select all
                if (controller.SelectAllEndPoints) {
                    controller.SelectedEndPoints = originalEndPoints.map(endPoint => endPoint);
                    controller.EndPoints = [];
                    // Not select all
                } else {
                    controller.SelectedEndPoints = [];
                    controller.EndPoints = originalEndPoints;
                }
            } else {
                controller.SelectedEndPoints.push(controller.AddedEndPoint);
                controller.EndPoints = controller.EndPoints.filter(endPoint => endPoint.Id != controller.AddedEndPoint.Id);
                controller.AddedEndPoint = null;
            }

            if (controller.SelectedEndPoints.length == originalEndPoints.length)
                controller.SelectAllEndPoints = true;
            else
                controller.SelectAllEndPoints = false;
        }

        vm.onRemoveEndPoint = (endPoint, controller) => {
            const originalEndPoints = angular.copy(vm.permissionEndPoints.filter(endPoint => endPoint.ApiControllerId == controller.Id));
            const endPointIndex = controller.SelectedEndPoints.indexOf(endPoint);

            // Get current end point index
            if (endPointIndex > -1)
                controller.SelectedEndPoints.splice(endPointIndex, 1);

            controller.EndPoints.push(endPoint);
            controller.EndPoints.sort((a, b) => a.Id - b.Id);

            if (controller.SelectedEndPoints.length == originalEndPoints.length)
                controller.SelectAllEndPoints = true;
            else
                controller.SelectAllEndPoints = false;
        }

        vm.saveApplication = (showLoading = true) => {
            if (showLoading)
                HelperService.startLoading('.loading-holder');

            let applicationData = angular.copy(vm.applicationData)

            applicationData.Application_AccessLevel = [];
            applicationData.Application_ApiEndPoint = [];
            applicationData.ApplicationTypeId = vm.selectedType.Id;

            if (vm.selectedAccessLevels.length) {
                applicationData.Application_AccessLevel = vm.selectedAccessLevels.reduce((acc, cur) => {
                    acc.push({
                        ApplicationId: applicationData.Id,
                        AccessLevelId: cur.Id
                    })

                    return acc;
                }, []);
            }

            if (applicationData.Id && vm.permissionControllers.length) {
                vm.permissionControllers.map(permission => {
                    if (permission.SelectedEndPoints.length) {
                        let permissionEndPoints = permission.SelectedEndPoints.reduce((acc, cur) => {
                            acc.push({
                                ApplicationId: applicationData.Id,
                                ApiEndPointId: cur.Id
                            });

                            return acc;
                        }, []);

                        permissionEndPoints.map(endPoint => applicationData.Application_ApiEndPoint.push(endPoint));
                    }
                });
            }

            if (!applicationData.Id) {
                applicationData.Image = '';

                ApplicationService
                    .post(applicationData)
                    .then(success => successCallback(success, true), errorCallback);
            } else {
                ApplicationService
                    .put(applicationData)
                    .then(successCallback, errorCallback);
            }
        }

        vm.deleteApplication = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Essa aplicação não conseguirá mais acessar o sistema!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.page-content');

                    ApplicationService
                        .delete(vm.applicationData.Id)
                        .then(() => {
                            $state.go('app.franchiser-applications-list');
                            HelperService.successCallback('delete');
                            HelperService.stopLoading('.page-content');
                        }, error => {
                            HelperService.stopLoading('.page-content');
                            HelperService.errorCallback(error);
                        })
                }
            })
        }

        init();

        function successCallback(success, isPost) {
            if (isPost) {
                HelperService.successCallback();

                vm.applicationData = success;

                $state.go('app.franchiser-applications-edit', {
                    applicationId: vm.applicationData.Id
                }, {
                        notify: false
                    });
            }

            angular.copy(vm.applicationData, applicationOriginalData);

            HelperService.successCallback('update');
            HelperService.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            HelperService.stopLoading('.loading-holder');
            HelperService.errorCallback(error);
        }

        function getApplication() {
            const applicationId = $stateParams.applicationId;

            if (!applicationId) {
                HelperService.stopLoading('.loading-holder');
                return;
            }

            ApplicationService
                .get(applicationId)
                .then(success => {
                    success.FormattedRegistrationDate = moment(success.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');

                    vm.applicationData = success;
                    applicationOriginalData = angular.copy(vm.applicationData);

                    vm.selectedType = vm.applicationTypes.find(type => (type.Id == success.ApplicationTypeId));

                    if (vm.applicationData.Image)
                        vm.imageMain.display = HelperService.imageHandlerPath('application', vm.applicationData.Id, vm.applicationData.Image);

                    if (vm.applicationData.Application_AccessLevel.length) {
                        vm.selectedAccessLevels = vm.accessLevels.filter(acc => {
                            if (vm.applicationData.Application_AccessLevel.find(commAcc => commAcc.AccessLevelId == acc.Id)) {
                                return acc;
                            }
                        });
                    }

                    if (vm.applicationData.Application_ApiEndPoint.length) {
                        vm.permissionControllers = vm.permissionControllers.map(controller => {
                            const originalEndPoints = angular.copy(vm.permissionEndPoints.filter(endPoint => endPoint.ApiControllerId == controller.Id));

                            if (vm.applicationData.Application_ApiEndPoint.find(appEndPoint => appEndPoint.ApiEndPoint.ApiControllerId == controller.Id)) {
                                controller.SelectedEndPoints = vm.applicationData.Application_ApiEndPoint.reduce((acc, cur) => {

                                    if (cur.ApiEndPoint.ApiControllerId == controller.Id) {
                                        acc.push(cur.ApiEndPoint);
                                        controller.EndPoints = controller.EndPoints.filter(ctrlEndPoint => ctrlEndPoint.Id != cur.ApiEndPointId);
                                    }

                                    return acc;
                                }, []);
                            }

                            if (controller.SelectedEndPoints.length == originalEndPoints.length)
                                controller.SelectAllEndPoints = true;
                            else
                                controller.SelectAllEndPoints = false;

                            return controller;
                        });
                    }

                    vm.permissionControllers.sort(function (a, b) {
                        if (a.Description < b.Description)
                            return -1;

                        if (b.Description < a.Description)
                            return 1;

                        return 0;
                    });

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        function getApplicationTypes() {
            return ApplicationTypeService
                .getAll()
                .then(success => {
                    vm.applicationTypes = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getApiControllers() {
            return ApplicationService
                .getApiControllers()
                .then(success => {
                    vm.permissionControllers = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getApiEndpoints() {
            return ApplicationService
                .getApiEndpoints()
                .then(success => {
                    vm.permissionEndPoints = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getAccessLevels() {
            return AccessLevelService
                .getAll()
                .then(success => {
                    vm.accessLevels = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function init() {
            vm.applicationData = {};
            vm.selectedTab = 1;

            vm.selectedAccessLevels = [];
            vm.selectAllAccessLevels = false;

            vm.imageMain = {
                display: ''
            }

            vm.flowOptionsMain = {
                query: () => {
                    return {
                        Path: `application/${vm.applicationData.Id}`,
                        OldImage: vm.oldFormImageMain,
                        CreateThumb: false,
                        CreateThumbAdmin: false
                    }
                }
            }

            angular.extend(vm.flowOptionsMain, HelperService.getFlowOptionsDefaults());

            HelperService.startLoading('.loading-holder');

            $q.all([getApiControllers(), getApiEndpoints(), getApplicationTypes(), getAccessLevels()])
                .then(() => {
                    for (let index = 0; index < vm.permissionControllers.length; index++) {
                        const controller = vm.permissionControllers[index];

                        controller.EndPoints = vm.permissionEndPoints.filter(endpoint => (endpoint.ApiControllerId == controller.Id));
                        controller.AddedEndPoint = null;
                        controller.SelectedEndPoints = [];
                    }

                    getApplication();
                });
        }
    }
}());